"use strict";

exports.__esModule = true;
exports.default = _default;

var _FilterDrawer = _interopRequireDefault(require("material-ui-shell/lib/components/FilterDrawer"));

var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Page = _interopRequireDefault(require("material-ui-shell/lib/containers/Page"));

var _react = _interopRequireDefault(require("react"));

var _SearchField = _interopRequireDefault(require("material-ui-shell/lib/components/SearchField"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _VirtualList = _interopRequireDefault(require("material-ui-shell/lib/containers/VirtualList"));

var _Filter = require("material-ui-shell/lib/providers/Filter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? [] : _props$fields,
      _props$list = props.list,
      source = _props$list === void 0 ? [] : _props$list,
      _props$getPageProps = props.getPageProps,
      getPageProps = _props$getPageProps === void 0 ? function () {} : _props$getPageProps,
      listProps = props.listProps,
      Row = props.Row,
      name = props.name,
      _props$trailing = props.trailing,
      trailing = _props$trailing === void 0 ? null : _props$trailing,
      _props$leading = props.leading,
      leading = _props$leading === void 0 ? null : _props$leading;

  var _useFilter = (0, _Filter.useFilter)(),
      openFilter = _useFilter.openFilter,
      getList = _useFilter.getList,
      getFilter = _useFilter.getFilter,
      setSearch = _useFilter.setSearch;

  var _getFilter = getFilter(name),
      _getFilter$queries = _getFilter.queries,
      queries = _getFilter$queries === void 0 ? [] : _getFilter$queries,
      _getFilter$search = _getFilter.search,
      search = _getFilter$search === void 0 ? {} : _getFilter$search;

  var _search$value = search.value,
      searchValue = _search$value === void 0 ? '' : _search$value;
  var list = getList(name, source, fields);
  return /*#__PURE__*/_react.default.createElement(_Page.default, _extends({
    contentStyle: {
      overflow: 'hidden'
    },
    appBarContent: /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
      disableGutters: true
    }, leading, /*#__PURE__*/_react.default.createElement(_SearchField.default, {
      initialValue: searchValue,
      onChange: function onChange(v) {
        setSearch(name, v);
      }
    }), fields.length > 0 && /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      color: "inherit",
      onClick: function onClick() {
        return openFilter(name);
      }
    }, /*#__PURE__*/_react.default.createElement(_FilterList.default, {
      color: queries.length > 0 ? 'secondary' : undefined
    })), trailing)
  }, getPageProps(list)), /*#__PURE__*/_react.default.createElement(_VirtualList.default, {
    list: list,
    name: name,
    listProps: listProps,
    Row: Row
  }), fields.length > 0 && /*#__PURE__*/_react.default.createElement(_FilterDrawer.default, {
    fields: fields,
    name: name
  }));
}

module.exports = exports.default;